import * as React from 'react';

function RotatingText({ items }: { items: string[] }) {
  const [index, setIndex] = React.useState(0);
  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    const timeout = setTimeout(() => setVisible(false), 1400);
    const id = setInterval(() => {
      setVisible(true);
      setIndex(i => (i + 1) % items.length);
      setTimeout(() => {
        setVisible(false);
      }, 1400);
    }, 1800);

    return () => {
      clearInterval(id);
      clearTimeout(timeout);
    };
  }, [items.length]);

  return (
    <span
      style={{
        margin: '0.4em',
        transition: 'opacity 0.4s, transform 0.4s',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(-10px)',
        display: 'inline-block'
      }}
    >
      {items[index]}
    </span>
  );
}

export default RotatingText;